import _ from 'lodash'

import { BasicFuncs } from '@react-awesome-query-builder/ui'
import { BootstrapConfig } from '@react-awesome-query-builder/bootstrap'
import '@react-awesome-query-builder/bootstrap/css/styles.css'
import moment from "moment"

import { _confirm, isProduction } from "@utils"
import { uuidv4 } from "@csrc/utility/Utils"
import { store } from '@csrc/redux/storeConfig/store'

import { _linkWithGlobalResponseSet, _publishTemplate, setSelectedItem } from "../redux/actions"
import { TemplateItems } from "@cmodules/checklist/utility/TemplateItemsConst"
import FieldSelect from "../views/template-builder/rules-modal/components/core/FieldSelect"
import React from "react"
import { RuleActionQuestion } from "./RuleActionsQuestionConst"
import { MultiBehaviourDatetimePicker } from "../../../components/multi-behaviour-datetime/index"
import {
  getClassesAndProps,
  getDateObjectForShapeFromObjectValue,
  getDatetimePartsForResponseFromDatetimePickerResponse
} from "@csrc/components/multi-behaviour-datetime/index.func"
import { DateTimeShapeValues } from "../assets/data/constants/date-time-shapes-values"

import { _checkCollapsedParentsByItem, _editTemplate } from "@cmodules/checklist/utility/template-builder-utilities"

const BasicConfig = BootstrapConfig
//******************  ******************//
export const setConflictModal = (payload) => {
  store.dispatch({
    type: "CLK_TEMPLATE_SET_MODALS_INFO",
    payload: { conflictModal: payload }
  })
}
//******************  ******************//
export const setPageDndModalShow = (payload) => {
  store.dispatch({
    type: "CLK_TEMPLATE_SET_MODALS_INFO",
    payload: { pageDndModalShow: payload }
  })
}
//******************  ******************//
export const setGroupOptionsModal = (payload) => {
  store.dispatch({
    type: "CLK_TEMPLATE_SET_MODALS_INFO",
    payload: { groupOptionsModal: payload }
  })
}
//******************  ******************//
export const setRelatedInfoModal = (payload) => {
  store.dispatch({
    type: "CLK_TEMPLATE_SET_MODALS_INFO",
    payload: { relatedInfoModal: payload }
  })
}
//******************  ******************//
export const setImageMarkerModal = (payload) => {
  store.dispatch({
    type: "CLK_TEMPLATE_SET_MODALS_INFO",
    payload: { imageMarkerModal: payload }
  })
}
//******************  ******************//
export const setRulesModal = (payload) => {
  const checklistStore = store.getState().checklist
  const localTemplate = checklistStore.template
  const targetItem = _.cloneDeep(payload?.item)
  if (_.size(checklistStore.ui.callStack) === 1) {
    const neededTemplate = localTemplate.global_items[checklistStore.ui.callStack[0]]
    if (neededTemplate?.present?.options.template_main_item_base_id === targetItem?.base_id) {
      targetItem.id = checklistStore.ui.callStack[0]
    }
  }
  store.dispatch({
    type: "CLK_TEMPLATE_SET_MODALS_INFO",
    payload: { rulesModal: { ...payload, item: targetItem } }
  })
}
//******************  ******************//
export const setRepeatingGroupModal = (payload) => {
  const checklistStore = store.getState().checklist
  const localTemplate = checklistStore.template
  const targetItem = _.cloneDeep(payload?.item)
  if (_.size(checklistStore.ui.callStack) === 1) {
    const neededTemplate = localTemplate.global_items[checklistStore.ui.callStack[0]]
    if (neededTemplate?.present?.options.template_main_item_base_id === targetItem?.base_id) {
      targetItem.id = checklistStore.ui.callStack[0]
    }
  }
  store.dispatch({
    type: "CLK_TEMPLATE_SET_MODALS_INFO",
    payload: { repeatingGroupModal: { ...payload, item: targetItem } }
  })
}
//******************  ******************//
export const setConflictedRulesModal = (payload) => {
  store.dispatch({
    type: "CLK_TEMPLATE_SET_MODALS_INFO",
    payload: { conflictedRules: payload }
  })
}
//******************  ******************//
/**
 * Feeds the review action bar shown after the option uuids of a list item were regenerated,
 * see utility/response-options/option-uuid-refresh.
 */
export const setChangedOptionsRulesModal = (payload) => {
  store.dispatch({
    type: "CLK_TEMPLATE_SET_MODALS_INFO",
    payload: { changedOptionsRules: payload }
  })
}
//******************  ******************//
/**
 * Feeds the confirmation modal shown *before* the rules referencing a changed option are updated.
 * The user chooses between an automatic re-pointing (recommended when the change is only a relabel
 * and therefore logically neutral) and opening the review wizard to fix each rule by hand, see
 * utility/response-options/option-uuid-refresh and views/template-builder/confirm-rule-update-modal.
 */
export const setConfirmRuleUpdateModal = (payload) => {
  store.dispatch({
    type: "CLK_TEMPLATE_SET_MODALS_INFO",
    payload: { confirmRuleUpdate: payload }
  })
}
//******************  ******************//
export const _deleteAllChild = (id, items, idKey = 'id', parentIdKey = 'parent_id') => {
  const arr = [id]
  // const resultArr = [id]
  items.forEach(x => {
    if (arr.includes(_.get(x, parentIdKey))) {
      arr.push(_.get(x, idKey))
      // resultArr.push(x)
    }
  })
  return items.filter(x => !arr.includes(_.get(x, idKey)))
}
//******************  ******************//
export const _deleteAllChildrenAndExcludeItem = (id, items, idKey = 'id', parentIdKey = 'parent_id') => {
  const arr = [id]
  // const resultArr = [id]
  items.forEach(x => {
    if (arr.includes(_.get(x, parentIdKey))) {
      arr.push(_.get(x, idKey))
      // resultArr.push(x)
    }
  })
  return items.filter(x => !arr.includes(_.get(x, idKey)) || _.get(x, idKey) === id)
}
//******************  ******************//
export const _deleteAllChildrenFromGroupOptions = (id) => {
  setGroupOptionsModal(prevState => {
    return {
      ...prevState,
      flatData: {
        ...prevState.flatData,
        items: _deleteAllChild(id, prevState.flatData.items, 'uuid', 'parent_uuid')
      }
    }
  })
}
//******************  ******************//
// export const injectRulesRelations = (template, relations, rule_sets) => {
//   _.forEach(_.filter(template.items, x => x.options.rule_set_id), related_item => {
//     const rule_set = _.get(rule_sets, related_item.options.rule_set_id)
//     _.forEach(rule_set.related_items, item_uuid => {
//       relations['outside'] = relations['outside'] ?? {}
//       relations['outside'][item_uuid] = relations['outside'][item_uuid] ?? {}
//       relations['outside'][item_uuid][related_item.id] = relations['outside'][item_uuid][related_item.id] ?? {uuid: related_item.id, rule_set: {}}
//       relations['outside'][item_uuid][related_item.id].rule_set_id = related_item.options.rule_set_id
//       relations['outside'][item_uuid][related_item.id].rule_set_behaviour = relations['outside'][item_uuid][related_item.id].rule_set_behaviour === 'inside' ? 'inside_outside' : 'outside'
//
//       relations['inside'] = relations['inside'] ?? {}
//       relations['inside'][related_item.id] = relations['inside'][related_item.id] ?? {}
//       relations['inside'][related_item.id][item_uuid] = relations['inside'][related_item.id][item_uuid] ?? {uuid: item_uuid, rule_set: {}}
//       relations['inside'][related_item.id][item_uuid].rule_set_id = related_item.options.rule_set_id
//       relations['inside'][related_item.id][item_uuid].rule_set_behaviour = relations['inside'][related_item.id][item_uuid].rule_set_behaviour === 'outside' ? 'inside_outside' : 'inside'
//     })
//     _.forEach(rule_set.action_items, item_uuid => {
//       relations['outside'] = relations['outside'] ?? {}
//       relations['outside'][item_uuid] = relations['outside'][item_uuid] ?? {}
//       relations['outside'][item_uuid][related_item.id] = relations['outside'][item_uuid][related_item.id] ?? {uuid: related_item.id, rule_set: {}}
//       relations['outside'][item_uuid][related_item.id].rule_set_id = related_item.options.rule_set_id
//       relations['outside'][item_uuid][related_item.id].rule_set_behaviour = relations['outside'][item_uuid][related_item.id].rule_set_behaviour === 'outside' ? 'inside_outside' : 'inside'
//
//       relations['inside'] = relations['inside'] ?? {}
//       relations['inside'][related_item.id] = relations['inside'][related_item.id] ?? {}
//       relations['inside'][related_item.id][item_uuid] = relations['inside'][related_item.id][item_uuid] ?? {uuid: item_uuid, rule_set: {}}
//       relations['inside'][related_item.id][item_uuid].rule_set_id = related_item.options.rule_set_id
//       relations['inside'][related_item.id][item_uuid].rule_set_behaviour = relations['inside'][related_item.id][item_uuid].rule_set_behaviour === 'inside' ? 'inside_outside' : 'outside'
//     })
//   })
//   return relations
// }
//******************  ******************//
export const injectRulesRelations = (template, relations, rule_sets) => {
  _.forEach(_.filter(template.items, x => x.options.rule_set_id), related_item => {
    const rule_set = _.get(rule_sets, related_item.options.rule_set_id)
    _.forEach(rule_set.related_items, item_uuid => {
      relations['outside'] = relations['outside'] ?? {}
      relations['outside'][item_uuid] = relations['outside'][item_uuid] ?? {}
      relations['outside'][item_uuid][related_item.id] = relations['outside'][item_uuid][related_item.id] ?? { uuid: related_item.id, rule_set: {} }
      relations['outside'][item_uuid][related_item.id].rule_set_id = related_item.options.rule_set_id
      relations['outside'][item_uuid][related_item.id].rule_set_behaviour = relations['outside'][item_uuid][related_item.id].rule_set_behaviour === 'inside' ? 'inside_outside' : 'outside'

      relations['inside'] = relations['inside'] ?? {}
      relations['inside'][related_item.id] = relations['inside'][related_item.id] ?? {}
      relations['inside'][related_item.id][item_uuid] = relations['inside'][related_item.id][item_uuid] ?? { uuid: item_uuid, rule_set: {} }
      relations['inside'][related_item.id][item_uuid].rule_set_id = related_item.options.rule_set_id
      relations['inside'][related_item.id][item_uuid].rule_set_behaviour = relations['inside'][related_item.id][item_uuid].rule_set_behaviour === 'outside' ? 'inside_outside' : 'inside'
    })
    _.forEach(rule_set.action_items, item_uuid => {
      relations['outside'] = relations['outside'] ?? {}
      relations['outside'][item_uuid] = relations['outside'][item_uuid] ?? {}
      relations['outside'][item_uuid][related_item.id] = relations['outside'][item_uuid][related_item.id] ?? { uuid: related_item.id, rule_set: {} }
      relations['outside'][item_uuid][related_item.id].rule_set_id = related_item.options.rule_set_id
      relations['outside'][item_uuid][related_item.id].rule_set_behaviour = relations['outside'][item_uuid][related_item.id].rule_set_behaviour === 'outside' ? 'inside_outside' : 'inside'

      relations['inside'] = relations['inside'] ?? {}
      relations['inside'][related_item.id] = relations['inside'][related_item.id] ?? {}
      relations['inside'][related_item.id][item_uuid] = relations['inside'][related_item.id][item_uuid] ?? { uuid: item_uuid, rule_set: {} }
      relations['inside'][related_item.id][item_uuid].rule_set_id = related_item.options.rule_set_id
      relations['inside'][related_item.id][item_uuid].rule_set_behaviour = relations['inside'][related_item.id][item_uuid].rule_set_behaviour === 'inside' ? 'inside_outside' : 'outside'
    })
  })
  return relations
}
//******************  ******************//
export const injectCalculationsRelations = (related_item, items, relations) => {
  if (TemplateItems[related_item.type].type === 'calculation') {
    _.forEach(related_item.options?.calculations?.items, item => {
      relations['outside'] = relations['outside'] ?? {}
      relations['outside'][item.id] = relations['outside'][item.id] ?? {}
      relations['outside'][item.id][related_item.id] = relations['outside'][item.id][related_item.id] ?? { uuid: related_item.id }
      relations['outside'][item.id][related_item.id].calculation = true
      relations['inside'] = relations['inside'] ?? {}
      relations['inside'][related_item.id] = relations['inside'][related_item.id] ?? {}
      relations['inside'][related_item.id][item.id] = relations['inside'][related_item.id][item.id] ?? { uuid: item.id }
      relations['inside'][related_item.id][item.id].calculation = true
    })
  }
  return relations
}
//******************  ******************//
export const injectDocumentIdRelations = (related_item, items, relations) => {
  if (TemplateItems[related_item.type].type === 'document_id') {
    _.forEach(related_item.options.items, item => {
      relations['outside'] = relations['outside'] ?? {}
      relations['outside'][item.id] = relations['outside'][item.id] ?? {}
      relations['outside'][item.id][related_item.id] = relations['outside'][item.id][related_item.id] ?? { uuid: related_item.id }
      relations['outside'][item.id][related_item.id].document_id = true
      relations['inside'] = relations['inside'] ?? {}
      relations['inside'][related_item.id] = relations['inside'][related_item.id] ?? {}
      relations['inside'][related_item.id][item.id] = relations['inside'][related_item.id][item.id] ?? { uuid: item.id }
      relations['inside'][related_item.id][item.id].document_id = true
    })
  }
  return relations
}
//******************  ******************//
export const syncRelations = (data) => {
  const templateData = data ?? store.getState().checklist.template
  const items = _.cloneDeep(templateData.present.items ?? [])
  let relations = {}
  _.forEach(items, x => {
    relations = injectCalculationsRelations(x, items, relations)
    relations = injectDocumentIdRelations(x, items, relations)
  })
  relations = injectRulesRelations(
    templateData.present,
    relations,
    templateData.rule_sets
  )
  return relations
}
//******************  ******************//
export const _setSelectedItemGroupedItems = (grouped_item_id, callBack) => {
  const template = store.getState().checklist.template
  const tempState = _.cloneDeep(template.present)
  const selectedItem = store.getState().checklist.ui.currentItem
  const tempItems = [...tempState.items]
  tempItems.find(x => x.id === selectedItem.id).options.grouped_item_id = grouped_item_id
  tempState.items = tempItems
  store.dispatch(
    _editTemplate(
      tempState,
      callBack
    )
  )
}
//******************  ******************//
export const checkIfExistInAnyRuleSet = (itemId) => {
  const template = store.getState().checklist.template
  const items = [...template.present.items.filter(x => x.options.rule_set_id)]
  let cond = false
  items.forEach(x => {
    if (_.indexOf(_.get(template, `rule_sets.${x?.options?.rule_set_id}.related_items`), itemId) > -1) {
      cond = true
    }
  })
  return cond
}
//******************  ******************//
export const _getPageChildrenByIndex = (_index, callback = () => { }) => {
  const template = store.getState().checklist.template
  let nextPageIndex = _.indexOf(template.present.items, _.find(template.present.items, (_e, _i) => TemplateItems[_e.type].type === 'page' && _i > _index))
  nextPageIndex = nextPageIndex > -1 ? nextPageIndex : (template.present.items.length)
  return _.slice(template.present.items, _index + 1, nextPageIndex)
}
//******************  ******************//
export const _getChildren = (item, itemsArr = null) => {
  const template = store.getState().checklist.template
  const items = itemsArr ?? template.present.items
  const childsArr = []
  items?.slice(_.findIndex(items, x => x.id === item?.id) + 1, items.length)?.every(x => {
    if (childsArr.find(a => a?.id === x?.parent_id) || item?.id === x?.parent_id) {
      childsArr.push(x)
      return true
    }
    return false
  })
  return childsArr
}
//******************  ******************//
export const _getParents = (item, arr = []) => {
  const template = store.getState().checklist.template
  const tempState = template.present
  const parent = _.find(tempState.items, x => x.id === item?.parent_id)
  if (parent) {
    arr.push(parent)
    return _getParents(parent, arr)
  } else {
    return arr
  }
}
//******************  ******************//
export const _getDirectParent = (item, arr = []) => {
  const template = store.getState().checklist.template
  const tempState = template.present
  return _.find(tempState.items, x => x.id === item?.parent_id)
}
//******************  ******************//
export const _getAllBranch = (item) => {
  const parents = _getParents(item)
  const children = _getChildren(item)
  return [
    ...parents,
    item,
    ...children
  ]
}
//******************  ******************//
export const _getSectionFirstLevelChildren = (section) => {
  const template = store.getState().checklist.template
  const tempState = _.cloneDeep(template.present)
  return tempState.items.filter(x => x.parent_id === section.id)
}
//******************  ******************//
export const _getIdAndIndexAndDepthIfAddingWhenSectionSelected = (selectedItem) => {
  const template = store.getState().checklist.template
  const item = template.present.items.find(x => x.id === selectedItem.id)
  const tempState = _.cloneDeep(template.present)
  if (item.collapsed) {
    let splicedItem = item
    if (_.size(_getChildren(item)) > 0) {
      const itemsInSection = _getChildren(item)
      splicedItem = itemsInSection[_.size(itemsInSection) - 1]
    }
    return {
      id: item.parent_id,
      depth: item.depth,
      index: _.findIndex(tempState.items, (x) => x.id === splicedItem.id) + 1
    }
  } else {
    return {
      id: item.id,
      depth: item.depth + 1,
      index: _.findIndex(tempState.items, (x) => x.id === item.id) + 1
    }
  }
}
//******************  ******************//
export const _prevItemsForRules = (item, withSelected = false, wantedTemplate = null) => {
  const template = wantedTemplate ?? store.getState().checklist.template
  const tempState = _.cloneDeep(template.present)
  const tempItems = tempState.items.map(x => {
    if (x.options?.global_item_id) {
      const globalItem = store.getState().checklist?.template?.global_items[x.id]
      return {
        ...x,
        title: globalItem?.present?.title
      }
    } else {
      return x
    }
  })
  const itemIndex = _.findIndex(tempItems, x => x.id === item.id)
  return tempItems.slice(0, withSelected ? itemIndex + 1 : itemIndex).filter(x => TemplateItems[x.type].asDependency)
}
//******************  ******************//
export const _nextItemsForRules = (item, withSelected = false, withSectionsAndPages = false, wantedTemplate = null) => {
  const template = wantedTemplate ?? store.getState().checklist.template
  const tempState = _.cloneDeep(template.present)
  const tempItems = tempState.items
  const itemIndex = _.findIndex(tempItems, x => x.id === item.id)
  return tempItems.slice(withSelected ? itemIndex : itemIndex + 1, tempItems.length).filter((x) => _.some(RuleActionQuestion, aa => _.get(aa, x.type)))
}
//******************  ******************//
export const getPreviousItems = (item, items = null, withSelected = false) => {
  const templateItems = items ?? store.getState().checklist.template.present.items
  const tempItems = templateItems.map(x => {
    if (x.options?.global_item_id) {
      const globalItem = store.getState().checklist?.template?.global_items[x.id]
      return {
        ...x,
        title: globalItem?.present?.title
      }
    } else {
      return x
    }
  })
  const itemIndex = _.findIndex(tempItems, x => x.id === item.id)
  return tempItems.slice(0, withSelected ? itemIndex + 1 : itemIndex)
}
//******************  ******************//
export const _setSelectedItemRuleSet = (ruleSetId, itemId, callBack) => {
  const template = store.getState().checklist.template
  const tempState = _.cloneDeep(template.present)
  const tempItems = tempState.items
  tempItems.find(x => x.id === itemId).options.rule_set_id = ruleSetId
  tempState.items = tempItems
  store.dispatch(
    _editTemplate(
      tempState,
      callBack
    )
  )
}
//******************  ******************//
export const _setInfoToItem = (itemId, infoId, callBack) => {
  const template = store.getState().checklist.template
  const tempState = _.cloneDeep(template.present)
  const tempItems = tempState.items
  tempItems.find(x => x.id === itemId).options.info_id = infoId
  tempState.items = tempItems
  store.dispatch(
    _editTemplate(
      tempState,
      callBack
    )
  )
}
//******************  ******************//
export const _setImageMarkerToItem = (itemId, id, callBack) => {
  const template = store.getState().checklist.template
  const tempState = _.cloneDeep(template.present)
  const tempItems = tempState.items
  tempItems.find(x => x.id === itemId).options.image_marker_id = id
  tempState.items = tempItems
  store.dispatch(
    _editTemplate(
      tempState,
      callBack
    )
  )
}
//******************  ******************//
export const _submitItemTypeModal = (props, callback = (finalData) => { }) => {
  const template = store.getState().checklist.template
  const { selectedType } = props
  switch (selectedType) {
    case 'list':
    case 'dropdown':
    case 'switch':
    case 'yesno':
      store.dispatch(_linkWithGlobalResponseSet(template.present.template_id, props, callback))
      break
    case 'photo':
      if (!_.isEmpty(props.data.options.quality)) {
        props.data.options.quality = props.data.options.quality.value
      }
      callback(props.data)
      break
    case 'video':
      if (!_.isEmpty(props.data.options.quality)) {
        props.data.options.quality = props.data.options.quality.value
      }
      callback(props.data)
      break
    case 'audio':
      if (!_.isEmpty(props.data.options.quality)) {
        props.data.options.quality = props.data.options.quality.value
      }
      callback(props.data)
      break
    default:
      callback(props.data)
  }
}
//******************  ******************//
export const _addPageToEmptyTemplate = () => {
  const template = store.getState().checklist.template
  const tempState = _.cloneDeep(template.present)
  const pageId = uuidv4()
  tempState.items = [
    ...tempState.items,
    { id: pageId, title: 'Page Title', type: 'page', depth: 0, options: {}, parent_id: null },
    { id: uuidv4(), title: 'Enter Title', type: 'textAnswer', depth: 0, options: {}, parent_id: pageId }
  ]
  store.dispatch(
    _editTemplate(
      tempState,
      () => {
      }
    )
  )
}
//******************  ******************//
export const _addStartPage = () => {
  const template = store.getState().checklist.template
  const tempState = _.cloneDeep(template.present)
  const pageId = uuidv4()
  tempState.items = [
    { id: pageId, title: 'Start page', type: 'start_page', depth: 0, options: {}, parent_id: null },
    { id: uuidv4(), title: 'Enter Title', type: 'textAnswer', depth: 0, options: {}, parent_id: pageId },
    ...tempState.items
  ]
  store.dispatch(
    _editTemplate(
      tempState,
      () => {
      }
    )
  )
}
//******************  ******************//
export const _addEndPage = () => {
  const template = store.getState().checklist.template
  const tempState = _.cloneDeep(template.present)
  const pageId = uuidv4()
  tempState.items = [
    ...tempState.items,
    { id: pageId, title: 'End page', type: 'end_page', depth: 0, options: {}, parent_id: null },
    { id: uuidv4(), title: 'Enter Title', type: 'textAnswer', depth: 0, options: {}, parent_id: pageId }
  ]
  store.dispatch(
    _editTemplate(
      tempState,
      () => {
      }
    )
  )
}
//******************  ******************//
export const _getChecklistWithHiddenPage = () => {
  const template = store.getState().checklist.template
  const tempState = _.cloneDeep(template.present)
  const pageId = uuidv4()
  const inspection_real_start_date = uuidv4()
  const inspection_real_end_date = uuidv4()
  const items = [
    {
      id: pageId,
      title: "Hidden Page",
      type: "hidden_page",
      options: {
        not_visible: true
      },
      parent_id: null,
      base_id: pageId,
      visible: false
    },
    {
      id: inspection_real_start_date,
      title: "Inspection real start date",
      type: "inspection_real_start_date",
      options: {
        not_visible: true
      },
      parent_id: pageId,
      base_id: inspection_real_start_date,
      visible: false
    },
    {
      id: inspection_real_end_date,
      title: "Inspection real end date",
      type: "inspection_real_end_date",
      options: {
        not_visible: true,
        required: true
      },
      parent_id: pageId,
      base_id: inspection_real_end_date,
      visible: false
    }
  ]
  if (!_.find(tempState.items, x => TemplateItems[x.type].type === 'hidden_page')) {
    tempState.items = [
      ...items,
      ...tempState.items.filter(x => TemplateItems[x.type].type !== 'inspection_real_start_date' && TemplateItems[x.type].type !== 'inspection_real_end_date')
    ]
  }
  return tempState.items
}
//******************  ******************//
export const _addPageAfterIndex = (pageIndex) => {
  const template = store.getState().checklist.template
  const tempState = _.cloneDeep(template.present)
  const pageId = uuidv4()
  const nextPageIndex = _.indexOf(tempState.items, _.find(tempState.items, (_e, _i) => TemplateItems[_e.type].behaviourType === 'page' && _i > pageIndex))
  if (nextPageIndex > -1) {
    tempState.items.splice(
      nextPageIndex, 0, {
      id: uuidv4(),
      title: 'Question Title',
      type: 'textAnswer',
      options: {},
      parent_id: pageId,
      depth: 0
    }
    )
    tempState.items.splice(
      nextPageIndex, 0, { id: pageId, title: 'Page Title', type: 'page', options: {}, parent_id: null, depth: 0 }
    )
  } else {
    tempState.items = [
      ...template.present.items,
      { id: pageId, title: 'Page Title', type: 'page', depth: 0, options: {}, parent_id: null },
      { id: uuidv4(), title: 'Enter Title', type: 'textAnswer', depth: 0, options: {}, parent_id: pageId }
    ]
  }
  store.dispatch(
    _editTemplate(
      tempState,
      () => {
      }
    )
  )
}
//******************  ******************//
// export const _addSection = (callback = () => {
// }) => {
//   const template = store.getState().checklist.template
//   const tempState = _.cloneDeep(template.present)
//   const revision = tempState.present.revision
//   tempState.past.push(tempState.present)
//   tempState.present = {
//     ...tempState.future[tempState.future.length - 1],
//     revision
//   }
//   tempState.future.pop()
//   return dispatch => {
//     store.dispatch({type: "CLK_TEMPLATE_REDO", payload: tempState})
//     _sendEditRequest(tempState.present.template_id, tempState.present)
//     callback()
//   }
// }
export const _getCollapsedItems = () => {
  const template = store.getState().checklist.template
  const tempState = _.cloneDeep(template.present)
  const tempItems = tempState.items
  return tempItems.filter(x => _checkCollapsedParentsByItem(x))
}
//******************  ******************//
export const _getActiveItems = () => {
  const template = store.getState().checklist.template
  const tempState = _.cloneDeep(template.present)
  const tempItems = tempState.items
  return tempItems.filter(x => !_checkCollapsedParentsByItem(x))
}
//******************  ******************//
export const getSectionFirstAvailableParentsIfClosed = (section) => {
  const tempItems = _getActiveItems()
  const parentItem = _.find(tempItems, x => x.id === section.parent_id)
  if (TemplateItems[parentItem.type].type === 'section') {
    if (parentItem.collapsed) {
      return getSectionFirstAvailableParentsIfClosed(parentItem)
    } else {
      return {
        parent_id: parentItem.id,
        depth: parentItem.depth + 1
      }
    }
  } else {
    return {
      parent_id: parentItem.id,
      depth: 0
    }
  }
}
//******************  ******************//
export const alertWrongPasteForGroupingAndRepeaterComponent = () => {
  return (
    <div className={'text-left'}>
      <p>A section with 'Grouped options' or 'Repeatable' is not allowed to its descendants or ancestors containing 'Grouped options' or 'Repeatable'</p>
    </div>
  )
}
//******************  ******************//
export function _depth(id, flatList) {
  const item = flatList.find(x => x.id === id)
  const parent_id = item?.parent_id
  const parent = flatList.find(x => x.id === item?.parent_id)

  /**
   * The item doesn't have parent_id is the page so it's depth is -1 because its first child starts with 0
   * If the parent is repeating group then the depth is the same as its parent because repeating group is not counted in depth
   * Otherwise the depth is parent's depth + 1
   */
  if (parent_id) {
    if (parent?.type === 'repeating_group') {
      return _depth(parent_id, flatList)
    } else {
      return _depth(parent_id, flatList) + 1
    }
  } else {
    return -1
  }
}
//******************  ******************//
export const getLiveItemsFromActive = (activeItems) => {
  const finalItems = []
  _.forEach(activeItems, activeItem => {
    if (TemplateItems[activeItem.type].type === 'section' && activeItem.collapsed) {
      finalItems.push(activeItem)
      _.forEach(_getChildren(activeItem), activeItemChild => {
        finalItems.push(activeItemChild)
      })
    } else {
      finalItems.push(activeItem)
    }
  })
  return finalItems
}
//******************  ******************//
/*
if action.type === 'dnd' then result will be the result from _onDragEnd function
 */
export const CheckRelations = ({ items, action: { type, result, activeItems, callback = () => { } } }, template) => {
  const templateData = template ?? store.getState().checklist.template
  const selectedItems = _.filter(templateData.present.items, x => _.indexOf(_.map(items, a => a.id), x.id) > -1)
  if (type === 'dnd') {
    const allItems = getLiveItemsFromActive(activeItems)
    if (
      !_.some(selectedItems, item => {
        const ItemIndex = _.findIndex(allItems, activeItem => activeItem.id === item.id)
        return (
          _.some(_.get(templateData.relations, `outside.[${item.id}]`), rel_item_rule => {
            const RelItemRuleIndex = _.findIndex(allItems, activeItem => activeItem.id === rel_item_rule.uuid)
            if (
              _.get(rel_item_rule, `calculation`) ||
              _.get(rel_item_rule, `document_id`) ||
              _.get(rel_item_rule, `rule_set_behaviour`) === 'outside' ||
              _.get(rel_item_rule, `rule_set_behaviour`) === 'inside_outside'
            ) {
              return ItemIndex > RelItemRuleIndex
            } else if (_.get(rel_item_rule, `rule_set_behaviour`) === 'inside' || _.get(rel_item_rule, `rule_set_behaviour`) === 'inside_outside') {
              return RelItemRuleIndex > ItemIndex
            } else {
              return false
            }
          })
          ||
          _.some(_.get(templateData.relations, `inside.[${item.id}]`), rel_item_rule => {
            const RelItemRuleIndex = _.findIndex(allItems, activeItem => activeItem.id === rel_item_rule.uuid)
            if (
              _.get(rel_item_rule, `calculation`) ||
              _.get(rel_item_rule, `document_id`) ||
              _.get(rel_item_rule, `rule_set_behaviour`) === 'inside' ||
              _.get(rel_item_rule, `rule_set_behaviour`) === 'inside_outside'
            ) {
              return RelItemRuleIndex > ItemIndex
            } else if (_.get(rel_item_rule, `rule_set_behaviour`) === 'outside' || _.get(rel_item_rule, `rule_set_behaviour`) === 'inside_outside') {
              return ItemIndex > RelItemRuleIndex
            } else {
              return false
            }
          })
        )
      })
    ) {
      setConflictedRulesModal({
        selectedItems: [],
        showModal: false,
        key: 0,
        action: {
          type: null,
          result: null
        }
      })
      return true
    }
    setConflictedRulesModal({
      selectedItems,
      showModal: true,
      key: Math.random() * 10000,
      action: {
        type,
        activeItems,
        result
      }
    })
  }
  if (type === 'delete' || type === 'delete_multiple') {
    if (
      !_.some(selectedItems, item => {
        const relations = _.get(templateData.relations, `outside.[${item.id}]`)
        return _.some(relations, (rel, item_id) => {
          return item_id !== item.id && !_.find(selectedItems, x => x.id === item_id) && (rel.calculation || rel.document_id || rel.rule_set_id)
        })
        // return (
        //   _.find(relations, x => x.calculation) ||
        //   _.find(relations, x => x.document_id) ||
        //   _.find(relations, x => x.rule_set_id)
        // )
      })
    ) {
      setConflictedRulesModal({
        selectedItems: [],
        showModal: false,
        key: 0,
        action: {
          type: null,
          result: null
        }
      })
      return true
    }
    setConflictedRulesModal({
      selectedItems,
      showModal: true,
      key: Math.random() * 10000,
      action: {
        type,
        callback
      }
    })
  }
  if (type === 'convert_to_global_item') {
    if (
      !_.some(selectedItems, item => {
        const relations = _.get(templateData.relations, `outside.[${item.id}]`)
        return _.some(relations, (rel, item_id) => {
          return item_id !== item.id && !_.find(selectedItems, x => x.id === item_id) && (rel.calculation || rel.document_id || rel.rule_set_id)
        })
        // return (
        //   _.find(relations, x => x.calculation) ||
        //   _.find(relations, x => x.document_id) ||
        //   _.find(relations, x => x.rule_set_id)
        // )
      }) &&
      !_.some(selectedItems, item => {
        const relations = _.get(templateData.relations, `inside.[${item.id}]`)
        return _.some(relations, (rel, item_id) => {
          return item_id !== item.id && !_.find(selectedItems, x => x.id === item_id) && (rel.rule_set_id)
        })
        // return (
        //   _.find(relations, x => x.calculation) ||
        //   _.find(relations, x => x.document_id) ||
        //   _.find(relations, x => x.rule_set_id)
        // )
      })
    ) {
      setConflictedRulesModal({
        selectedItems: [],
        showModal: false,
        key: 0,
        action: {
          type: null,
          result: null
        }
      })
      return true
    }
    setConflictedRulesModal({
      selectedItems,
      showModal: true,
      key: Math.random() * 10000,
      action: {
        type,
        callback
      }
    })
  }
  return false
}
//******************  ******************//
/**
 * Validates drag-and-drop accessibility by enforcing template composition rules.
 * See ./README.md#adr--decisions for ADR-checklist-utility-templatebuilder-#006 and #007.
 * 
 * @param {Object} draggedItem - The item being dragged
 * @param {Object} destinationPreviousItem - The item after which the dragged item will be placed
 * @returns {boolean} true if the drop is allowed, false if it violates composition rules
 */
export const CheckRulesForDragAndDropAccessibility = (draggedItem, destinationPreviousItem) => {
  const template = store.getState().checklist.template
  const childrenItems = [..._getChildren(draggedItem)]
  const childrenItemsWithCurrent = [...childrenItems, draggedItem]
  let parentItems = [..._getParents(destinationPreviousItem), destinationPreviousItem]

  // Avoid calculating the previous item as a parent if it is a closed section
  // This ensures the item and the section will be at the same level, not nested
  if (
    (
      TemplateItems[destinationPreviousItem.type].type === 'section' &&
      destinationPreviousItem.collapsed
    ) || TemplateItems[destinationPreviousItem.type].type !== 'section'
  ) {
    parentItems = _.filter(parentItems, x => x.id !== destinationPreviousItem.id)
  }
  let accessibilityCondition = true

  // ADR-checklist-utility-templatebuilder-#006: Prevent combination between repeatable and grouping in the same branch.
  // Repeatable groups (dynamic array) and grouped items (static option grouping) have conflicting semantics.
  if (
    (_.find(childrenItemsWithCurrent, x => x?.options?.repeatable)) &&
    (_.find(parentItems, x => x?.options?.grouped_item_id))
  ) {
    accessibilityCondition = false
  }

  // ADR-checklist-utility-templatebuilder-#007: Check whether the template is a global item with type 'section' to prevent root drop.
  // Global section templates must maintain a single immutable root section; items cannot be dragged beyond page boundaries.
  if (TemplateItems[destinationPreviousItem.type].type === 'page' && store.getState().checklist.template.present.options.template_type === 'section') {
    accessibilityCondition = false
  }
  return accessibilityCondition
}
//******************  ******************//
export const _onDragStart = (result) => {
  const template = store.getState().checklist.template
  const { source } = result
  const itemId = result.draggableId
  const droppable = document.getElementsByClassName(`template-page-${source.droppableId}`)[0]
  const currentItem = template.present.items.find(x => x.id === itemId)
  droppable.classList.add(`depth-${currentItem.depth}`)
}
//******************  ******************//
export const _onDragUpdate = (result) => {

  const { source, destination, draggableId } = result
  if (!destination) {
    return
  }

  const droppable = document.getElementsByClassName(`template-page-${destination.droppableId}`)[0];
  [].forEach.call(document.querySelectorAll(".indentation"), function (itm) {
    itm.classList.remove('indentation-active')
    itm.classList.remove('indentation-show')
  })

  const classes = droppable.className.split(' ') // Get all classes
  for (let i = 0; i < classes.length; i++) {
    if (classes[i].startsWith('depth-')) {
      droppable.classList.remove(classes[i])
    }
  }
  droppable.classList.remove('bg-prevent-dragging')

  // Get only active items (without hidden and collapsed items)
  let activeItems = _.cloneDeep(_getActiveItems())

  const sourcePage = _.find(activeItems, x => x.id === source.droppableId)
  const destinationPage = _.find(activeItems, x => x.id === destination.droppableId)
  // dropped outside the list
  if (
    (
      TemplateItems[sourcePage.type].subType === 'start' &&
      TemplateItems[destinationPage.type].subType !== 'start'
    ) ||
    (
      TemplateItems[sourcePage.type].subType === 'end' &&
      TemplateItems[destinationPage.type].subType !== 'end'
    )
  ) {
    droppable.classList.add(`bg-prevent-dragging`)
    return
  }

  const draggedItem = _.find(activeItems, x => x.id === draggableId)
  const sourcePageIndex = _.findIndex(activeItems, x => x.id === source.droppableId)
  const sourceItemIndex = sourcePageIndex + source.index + 1

  activeItems = Array.from(activeItems)
  // Remove dragged item
  const removed = activeItems.splice(sourceItemIndex, 1)

  // Get the index of the droppable page after removing the dragged item
  const destinationPageIndex = _.findIndex(activeItems, x => x.id === destination.droppableId)
  // Get the final destination index
  const destinationIndex = destinationPageIndex + destination.index + 1
  // Inject dragged item into destination index
  activeItems.splice(destinationIndex, 0, ...removed)

  // Get destination previous item after inserting in right place to check whether it is section or normal item
  const destinationPreviousItem = activeItems[destinationIndex - 1]

  if (!CheckRulesForDragAndDropAccessibility(draggedItem, destinationPreviousItem)) {
    droppable.classList.add(`bg-prevent-dragging`)
  }

  let depth = 0
  if (destination.index === 0) {

  } else if (
    TemplateItems[destinationPreviousItem.type].type === 'repeating_group'
  ) {
    droppable.classList.add(`depth-${destinationPreviousItem.depth}`)
    depth = destinationPreviousItem.depth
  } else if ((TemplateItems[destinationPreviousItem.type].type === 'section' && !destinationPreviousItem.collapsed) || TemplateItems[destinationPreviousItem.type].type === 'page') {
    droppable.classList.add(`depth-${destinationPreviousItem.depth + 1}`)
    depth = destinationPreviousItem.depth + 1
  } else {
    droppable.classList.add(`depth-${destinationPreviousItem.depth}`)
    depth = destinationPreviousItem.depth
  }

  [].forEach.call(document.querySelectorAll(".indentation"), function (itm) {
    for (let i = depth; i <= Math.max.apply(Math, activeItems.map(function (x) { return x.depth })); i++) {
      if (itm.classList.contains(`dep-${i}`)) {
        itm.classList.add('indentation-show')
        break
      }
    }
  })
}
//******************  ******************//
export const _onDragEnd = (result) => {
  const template = store.getState().checklist.template;
  [].forEach.call(document.querySelectorAll(".indentation"), function (itm) {
    itm.classList.remove('indentation-active')
    itm.classList.remove('indentation-show')
  })

  const { source, destination, draggableId } = result
  if (!destination) {
    return
  }
  // Get only active items (without hidden and collapsed items)
  let activeItems = _.cloneDeep(_getActiveItems())

  const sourcePage = _.find(activeItems, x => x.id === source.droppableId)
  const destinationPage = _.find(activeItems, x => x.id === destination.droppableId)
  // dropped outside the list
  if (
    (
      TemplateItems[sourcePage.type].subType === 'start' &&
      TemplateItems[destinationPage.type].subType !== 'start'
    ) ||
    (
      TemplateItems[sourcePage.type].subType === 'end' &&
      TemplateItems[destinationPage.type].subType !== 'end'
    )
  ) {
    return
  }

  const draggedItem = _.find(activeItems, x => x.id === draggableId)
  const sourcePageIndex = _.findIndex(activeItems, x => x.id === source.droppableId)
  const sourceItemIndex = sourcePageIndex + source.index + 1

  activeItems = Array.from(activeItems)
  // Remove dragged item
  const removed = activeItems.splice(sourceItemIndex, 1)

  // Get the index of the droppable page after removing the dragged item
  const destinationPageIndex = _.findIndex(activeItems, x => x.id === destination.droppableId)
  // Get the final destination index
  const destinationIndex = destinationPageIndex + destination.index + 1
  // Inject dragged item into destination index
  activeItems.splice(destinationIndex, 0, ...removed)

  // Get destination previous item after inserting in right place to check whether it is section or normal item
  const destinationPreviousItem = activeItems[destinationIndex - 1]

  if (!CheckRulesForDragAndDropAccessibility(draggedItem, destinationPreviousItem)) {
    return
  }

  if (source.droppableId === destination.droppableId && source.index === destination.index) {
    return
  }
  let selectedItems = []
  if (_.get(TemplateItems, `${draggedItem.type}.type`) !== 'section') {
    selectedItems = [draggedItem]
  } else {
    selectedItems = [draggedItem, ..._getChildren(draggedItem)]
  }
  const canContinue = CheckRelations({ items: selectedItems, action: { type: 'dnd', result, activeItems } })
  if (!canContinue) {
    return false
  }
  store.dispatch(
    _editTemplate(
      reOrder(result),
      () => {
      }
    )
  )
}
//******************  ******************//
export const reOrder = (result) => {
  const template = _.cloneDeep(store.getState().checklist.template)
  const tempTemplate = template.present

  // Get only active items (without hidden and collapsed items)
  let activeItems = _.cloneDeep(_getActiveItems())

  const draggedItem = _.cloneDeep(_.find(activeItems, x => x.id === result.draggableId))
  const sourcePageIndex = _.findIndex(activeItems, x => x.id === result.source.droppableId)
  const sourceItemIndex = sourcePageIndex + result.source.index + 1

  activeItems = Array.from(activeItems)
  // Remove dragged item
  const removed = activeItems.splice(sourceItemIndex, 1)

  // Get the index of the droppable page after removing the dragged item
  const destinationPageIndex = _.findIndex(activeItems, x => x.id === result.destination.droppableId)
  // Get the final destination index
  const destinationIndex = destinationPageIndex + result.destination.index + 1
  // Inject dragged item into destination index
  activeItems.splice(destinationIndex, 0, ...removed)

  // Get destination previous item after inserting in right place to check whether it is section or normal item
  const destinationPreviousItem = activeItems[destinationIndex - 1]

  /* Recalculate parent_id and depth id depending on previous item after injecting dragged into destination */
  // By default, parent_id & depth will be the same of the previous item
  let parent_id = destinationPreviousItem.parent_id
  let depth = destinationPreviousItem.depth

  if (result.destination.index === 0) {
    parent_id = result.destination.droppableId
    depth = 0
  }

  // If previous item is an expanded section so the parent_id will be the section and depth will be the (depth of section + 1)
  if (TemplateItems[destinationPreviousItem.type].type === 'section') {
    if (!destinationPreviousItem.collapsed) {
      parent_id = destinationPreviousItem.id
      depth = destinationPreviousItem.depth + 1
    }
  }
  activeItems[destinationIndex].parent_id = parent_id
  activeItems[destinationIndex].depth = depth

  // After working on active items we should reinject all collapsed items
  const items = []
  _.forEach(activeItems, activeItem => {
    items.push(activeItem)
    if (TemplateItems[activeItem.type].type === 'section' && activeItem.collapsed) {
      if (activeItem.id === draggedItem.id) {
        // If the dragged item was a collapsed section we should recalculate the depth
        _.forEach(_getChildren(activeItem), activeItemChild => {
          items.push({ ...activeItemChild, depth: _depth(activeItemChild.id, [...items, activeItemChild]) })
        })
      } else {
        _.forEach(_getChildren(activeItem), activeItemChild => {
          items.push(activeItemChild)
        })
      }
    }
  })

  tempTemplate.items = items

  return {
    ...tempTemplate,
    itemId: draggedItem.id
  }

}
//******************  ******************//
export const _changeQuestionRequired = (check, item) => {
  const template = store.getState().checklist.template
  const tempState = _.cloneDeep(template.present)
  tempState.items.find(x => x.id === item.id).options.required = check
  store.dispatch(_editTemplate(tempState))
}
//******************  ******************//
export const _changeItemAttr = ({ attr, value }, item) => {
  const template = store.getState().checklist.template
  const tempState = _.cloneDeep(template.present)
  tempState.items.find(x => x.id === item.id).options[attr] = value
  store.dispatch(_editTemplate(tempState))
}
//******************  ******************//
export const publishTemplate = (id, title, text, confirmButtonText, width, callback = () => { }, callbackErr = () => { }) => {
  _confirm({
    title,
    text,
    confirmButtonText,
    width,
    callback: (confirmed) => {
      _publishTemplate(
        id,
        () => {
          confirmed()
          callback()
        },
        callbackErr
      )
    }
  })
}
//******************  ******************//
/**
 * 
 * @param {import('../assets/data/types/vm/template-builder/item').AnyItemVM} item 
 * @returns 
 */
const getItemConfigurationForQueryBuilder = (item, passedTemplate = null) => {
  const template = passedTemplate || store.getState().checklist.template
  const itemConfigData = TemplateItems[item.type]
  const x = _.cloneDeep(item)
  const { type } = itemConfigData
  let response_sets = template.response_sets
  if (x.options.global_item_id) {
    const globalTemplate = template.global_items[x.id]
    if (globalTemplate) {
      const mainItem = globalTemplate.present.items.find(i => i.base_id === globalTemplate?.present?.options?.template_main_item_base_id)
      x.options = mainItem.options
      response_sets = {
        ...response_sets,
        ...globalTemplate?.response_sets
      }
    }
  }

  if (type === 'issues_count' || type === 'counter' || type === 'constant' || type === 'calculation') {
    return {
      label: x.title,
      type: itemConfigData.behaviourType,
      valueSources: ['value', 'field'],
      preferWidgets: ['number']
    }
  } else if (type === 'number') {
    const fieldSettings = {}
    if (x.options.min > 0) {
      fieldSettings['min'] = x.options.min
    }
    if (x.options.max > 0) {
      fieldSettings['max'] = x.options.max
    }
    return {
      label: x.title,
      type: itemConfigData.behaviourType,
      valueSources: ['value', 'field'],
      fieldSettings,
      preferWidgets: ['number']
    }
  } else if (type === 'asset' || type === 'textAnswer' || type === 'longText' || type === 'dataset' || type === 'site' || type === 'document_id') {
    return {
      label: x.title,
      type: itemConfigData.behaviourType,
      valueSources: ['value', 'field'],
      preferWidgets: ['text']
    }
  } else if (type === 'asset_field' || type === 'assignment_field' || type === 'global_list') {
    return {
      label: x.title,
      type: x.options.value_type ?? 'text',
      valueSources: ['value', 'field'],
      preferWidgets: [x.options.value_type]
    }
  } else if (type === 'slider') {
    return {
      label: x.title,
      type: itemConfigData.behaviourType,
      valueSources: ['value'],
      fieldSettings: {
        min: x.options.min,
        max: x.options.max
      },
      preferWidgets: ['slider', 'rangeslider']
    }
  } else if (type === 'list' || type === 'dropdown' || type === 'yesno' || type === 'oknot' || type === 'switch') {
    const responseSet = _.find(response_sets, set => set.uuid === x.options.response_set_id)
    if (responseSet) {
      return {
        label: x.title,
        type: x.options.multiple_selection ? 'multiselect' : 'select',
        valueSources: ['value'],
        fieldSettings: {
          listValues: _.map(responseSet.options, option => {
            return { title: option.label, value: option.uuid }
          })
        }
      }
    }
  } else if (type === 'datetime') {
    let inputType = ''
    if (x.options.date) inputType = 'date'
    if (x.options.time) inputType = 'time'
    if (x.options.date && x.options.time) inputType = 'datetime'
    return {
      label: x.title,
      // type: inputType,
      type: isProduction() ? inputType : 'datetime',
      valueSources: ['value', 'field', 'func'],
      fieldSettings: {
        // valueFormat: 'DD-MM-YYYY'
      }
    }
    // if (x.options.date) {
    //   inputType = 'date'
    //   return {
    //     label: x.title,
    //     type: inputType,
    //     valueSources: ['value', 'field', 'func'],
    //     fieldSettings: {},
    //     funcs:['DATE_NOW', 'DATE_RELATIVE_DATETIME']
    //   }
    // }
  } else if (type === 'checkbox') {
    return {
      label: x.title,
      type: 'boolean',
      valueSources: ['value', 'field'],
      fieldSettings: {}
    }
  }
}
//******************  ******************//
export const mapPrevItemsToQueryBuilder = (prevItems, template = null) => {
  const fields = {}
  prevItems.forEach(x => {
    const field = getItemConfigurationForQueryBuilder(x, template)
    if (field) {
      fields[x.id] = field
    }
  })
  return fields
}
//******************  ******************//
export const multiselect_contains = {
  label: "Exists in",
  labelForFormat: "EXISTS IN",
  formatOp: (field, op, values, valueSrc, valueType, opDef, operatorOptions, isForDisplay) => {
    if (valueSrc === "value") {
      return `${field} EXISTS IN (${values.join(", ")})`
    } else {
      return `${field} EXISTS IN ${values}`
    }
  },
  reversedOp: "multiselect_not_contains",
  jsonLogic2: "some-in",
  jsonLogic: (field, op, vals) => ({
    some: [field, { in: [{ var: "" }, vals] }]
  })
}
//******************  ******************//
export const multiselect_not_contains = {
  isNotOp: true,
  label: "Not exists in",
  labelForFormat: "NOT EXISTS IN",
  formatOp: (field, op, values, valueSrc, valueType, opDef, operatorOptions, isForDisplay) => {
    if (valueSrc === "value") return `${field} NOT EXISTS IN (${values.join(", ")})`
    else return `${field} NOT EXISTS IN ${values}`
  },
  reversedOp: "multiselect_contains"
}
//******************  ******************//
export const multiselect_exact = {
  label: "Equals",
  labelForFormat: "EQUALS",
  formatOp: (field, op, values, valueSrc, valueType, opDef, operatorOptions, isForDisplay) => {
    if (valueSrc === "value") {
      return `${field} EXACT (${values.join(", ")})`
    } else {
      return `${field} EXACT ${values}`
    }
  },
  reversedOp: "multiselect_not_exact",
  jsonLogic2: "exact-in",
  jsonLogic: (field, op, vals) => ({
    exact: [field, { in: [{ var: "" }, vals] }]
  })
}
//******************  ******************//
export const multiselect_not_exact = {
  isNotOp: true,
  label: "Not Equals",
  labelForFormat: "NOT EQUALS",
  formatOp: (field, op, values, valueSrc, valueType, opDef, operatorOptions, isForDisplay) => {
    if (valueSrc === "value") return `${field} NOT EXACT (${values.join(", ")})`
    else return `${field} NOT EXACT ${values}`
  },
  reversedOp: "multiselect_exact"
}
//******************  ******************//
export const multiselect_equals = {
  label: "All in",
  labelForFormat: "ALL IN",
  formatOp: (field, op, values, valueSrc, valueType, opDef, operatorOptions, isForDisplay) => {
    if (valueSrc === "value") {
      return `${field} ALL IN (${values.join(", ")})`
    } else {
      return `${field} ALL IN ${values}`
    }
  },
  reversedOp: "multiselect_not_equals",
  jsonLogic2: "all",
  jsonLogic: (field, op, vals) => ({
    all: [field, { in: [{ var: "" }, vals] }]
  })
}
//******************  ******************//
export const multiselect_not_equals = {
  isNotOp: true,
  label: "All not in",
  labelForFormat: "ALL NOT IN",
  formatOp: (field, op, values, valueSrc, valueType, opDef, operatorOptions, isForDisplay) => {
    if (valueSrc === "value") return `${field} ALL NOT IN (${values.join(", ")})`
    else return `${field} ALL NOT IN ${values}`
  },
  reversedOp: "multiselect_equals"
}
//******************  ******************//
export const types = {
  ...BasicConfig.types,
  multiselect: _.merge(BasicConfig.types.multiselect, {
    operators: [
      "multiselect_exact",
      "multiselect_not_exact",
      "multiselect_contains",
      "multiselect_not_contains",
      "multiselect_equals",
      "multiselect_not_equals",
      "is_null",
      "is_not_null"
    ],
    widgets:
    {
      multiselect: {
        operators: [
          "multiselect_exact",
          "multiselect_not_exact",
          "multiselect_contains",
          "multiselect_not_contains",
          "multiselect_equals",
          "multiselect_not_equals",
          "is_null",
          "is_not_null"
        ]
      }
    }
  })
}
//******************  ******************//
export const operators = {
  ...BasicConfig.operators,
  multiselect_contains,
  multiselect_not_contains,
  multiselect_exact,
  multiselect_not_exact,
  multiselect_equals,
  multiselect_not_equals
}
//******************  ******************//
export const settings = {
  ...BasicConfig.settings,
  renderField: (props) => <FieldSelect {...props} />,
  showErrorMessage: true
}
//******************  ******************//
export const funcs = {
  ...BasicFuncs,
  DATE_NOW: {
    label: "Current date",
    jsonLogic: "current_date",
    jsonLogicCustomOps: {
      current_date: {}
    },
    spelFunc: "T(java.time.LocalDateTime).now()",
    returnType: 'date'
  },
  DATE_RELATIVE_DATETIME: {
    ...BasicFuncs.RELATIVE_DATETIME,
    args: {
      ...BasicFuncs.RELATIVE_DATETIME.args,
      date: {
        label: "Date",
        type: "date",
        defaultValue: {
          func: "DATE_NOW",
          args: []
        },
        valueSources: [
          "func",
          "field"
        ]
      }
    },
    returnType: 'date'
  }
}
//******************  ******************//
// const enableDatetimeParts = isProduction()
const enableLegacyDatetime = true
//******************  ******************//
const datetimeWidgetProps = enableLegacyDatetime ? {
  ...BasicConfig.widgets.datetime,
  jsonLogic: (val, fieldSetting) => {
    return moment(val).format('YYYY-MM-DDTHH:mm:ss')
  }
} : {
  ...BasicConfig.widgets.datetime,
  factory: (props) => {
    const item = _.find(store.getState().checklist.template.present.items, x => x.id === props.field)
    const datetimeShape = _.find(DateTimeShapeValues, x => x.value === item.options.date_time_shape)
    let date = {}
    try {
      date = JSON.parse(props.value)
    } catch (e) {

    }
    const value = getDateObjectForShapeFromObjectValue(datetimeShape.value, props.value ? date : {})
    const datetimePickerDetails = getClassesAndProps(datetimeShape)
    return (
      <MultiBehaviourDatetimePicker
        value={value}
        datetimeShape={datetimeShape}
        onChange={(value) => props.setValue(JSON.stringify(getDatetimePartsForResponseFromDatetimePickerResponse({
          datetimePickerDetails,
          datetimeShape
        }, value)))}
      />
    )
  },
  jsonLogic: (val, fieldSetting) => {
    return val
  }
}
//******************  ******************//
export const widgets = {
  ...BasicConfig.widgets,
  datetime: datetimeWidgetProps,
  date: {
    ...BasicConfig.widgets.date,
    jsonLogic: (val, fieldSetting) => {
      return moment(val).format('YYYY-MM-DDTHH:mm:ss')
    }
  }
}
//******************  ******************//
export const reactAwesomeQueryBuilderConfig = {
  ...BasicConfig,
  // fields,
  settings,
  operators,
  types,
  widgets,
  funcs
}
//******************  ******************//
export const addSection = (item) => {
  const currentItem = store.getState().checklist.ui.currentItem
  const template = store.getState().checklist.template
  const selectedItem = _.find(template.present.items, x => x.id === currentItem.id)
  const selected = item ?? selectedItem
  const tempTemplate = _.cloneDeep(template.present)
  const sectionUUID = uuidv4()
  const newSection = {
    id: sectionUUID,
    title: 'Section Title',
    type: 'section',
    options: {},
    parent_id: TemplateItems[selected.type].type === 'section' || TemplateItems[selected.type].behaviourType === 'page' ? _getIdAndIndexAndDepthIfAddingWhenSectionSelected(selected).id : selected.parent_id,
    depth: TemplateItems[selected.type].type === 'section' || TemplateItems[selected.type].behaviourType === 'page' ? _getIdAndIndexAndDepthIfAddingWhenSectionSelected(selected).depth : selected.depth
  }

  // const lastChild = _.findLast(tempTemplate.items, x => x.parent_id === selected.id)
  // if (lastChild) {
  // 	tempTemplate.items.splice(_.findIndex(template.present.items, (x) => x.id === lastChild.id) + 1, 0, newSection)
  // } else {
  tempTemplate.items.splice(_getIdAndIndexAndDepthIfAddingWhenSectionSelected(selected).index, 0, newSection)
  // }

  // const	newQuestion = {
  // 	id:uuidv4(),
  // 	title:'Question Title',
  // 	type:'textAnswer',
  // 	options:{},
  // 	parent_id:sectionUUID,
  // 	depth:newSection.depth + 1
  // }
  // tempTemplate.items.splice(_.findIndex(template.present.items, (x) => x.id === sectionUUID) + 1, 0, newQuestion)
  store.dispatch(
    _editTemplate(
      tempTemplate,
      () => store.dispatch(setSelectedItem(newSection))
    )
  )
}
/**
 * ============================================================================
 * MOBILE PREVIEW DATA MAPPING LAYER
 * ============================================================================
 * 
 * These functions serve as a translation layer between two data structures:
 * 
 * WEB (Template Builder):          MOBILE (Preview App):
 * - Items store IDs as references  - Items need resolved objects
 * - { response_set_id: "abc" }  →  { response: { options: [...] } }
 * 
 * Why this separation exists:
 * - Web uses normalized data (IDs) to avoid duplication and simplify updates
 * - Mobile expects denormalized data (resolved objects) to reduce lookups
 * 
 * Mapping Strategy:
 * Web Field ID              →  Mobile Preview Field
 * options.response_set_id   →  response (full response set object)
 * options.rule_set_id       →  rule_set (full rule set object)
 * options.grouped_item_id   →  grouped_item (full grouped item object)
 * options.image_marker_id   →  image_marker (full image marker object)
 * options.info_id           →  info (full info object)
 */

/**
 * Resolves a single item's ID-based references to their full objects.
 * 
 * @param {Object} item - Template item with ID references in options
 * @param {Object} data - Lookup tables for resolving IDs to objects
 * @returns {Object} Item with resolved object references for mobile preview
 */
export const generateItemForPreview = (item, data = {}) => {
  const templateData = store.getState().checklist.template
  const {
    response_sets = _.cloneDeep(data?.response_sets ?? templateData.response_sets),
    rule_sets = _.cloneDeep(data?.rule_sets ?? templateData.rule_sets),
    grouped_items = _.cloneDeep(data?.grouped_items ?? templateData.grouped_items),
    image_markers = _.cloneDeep(data?.image_markers ?? templateData.image_markers),
    infos = _.cloneDeep(data?.infos ?? templateData.info)
  } = data

  // Map: Web ID field → Mobile preview field → Resolved object
  return {
    ...item,
    response: _.get(item, 'options.response_set_id') ? (response_sets[item.options.response_set_id] ?? item?.response) : null,
    rule_set: _.get(item, 'options.rule_set_id') ? (rule_sets[item.options.rule_set_id] ?? item?.rule_set) : null,
    grouped_item: _.get(item, 'options.grouped_item_id') ? (grouped_items[item.options.grouped_item_id] ?? item?.grouped_item) : null,
    image_marker: _.get(item, 'options.image_marker_id') ? (image_markers[item.options.image_marker_id] ?? item?.image_marker) : null,
    info: _.get(item, 'options.info_id') ? (infos[item.options.info_id] ?? item?.info) : null
  }
}

/**
 * Transforms template items from web format (ID references) to mobile preview format (resolved objects).
 * 
 * @param {Object} props - Override options for data sources
 * @returns {Array} Items with resolved references ready for mobile preview
 */
export const generatePreviewData = (props = {}) => {
  const templateData = store.getState().checklist.template

  // Extract with defaults from current template state
  const {
    items = _.cloneDeep(props?.items ?? templateData?.present?.items),
    response_sets = _.cloneDeep(props?.response_sets ?? templateData.response_sets),
    rule_sets = _.cloneDeep(props?.rule_sets ?? templateData.rule_sets),
    grouped_items = _.cloneDeep(props?.grouped_items ?? templateData.grouped_items),
    image_markers = _.cloneDeep(props?.image_markers ?? templateData.image_markers),
    infos = _.cloneDeep(props?.info ?? templateData.info)
  } = props

  // Transform each item from web format → mobile preview format
  const lookupData = { response_sets, rule_sets, grouped_items, image_markers, infos }

  return _.map(items, item => generateItemForPreview(item, lookupData))
}
//******************  ******************//
export const CheckDisablingGroupedAndRepeaterInTreeBranchForItem = (item) => {
  const template = store.getState().checklist.template
  if (!item) return { repeatable: false, grouping: false }

  // Resolve item in the current template if possible
  const itemInTemplate = template.present.items.find(x => x.id === item.id) ?? item
  const parents = itemInTemplate?.id ? _getParents(itemInTemplate) : []
  const children = itemInTemplate?.id ? _getChildren(itemInTemplate) : []


  // const isParentsHasRepeatable = _.some([...parents], x => !!x?.options?.repeatable)
  const isChildrenHasRepeatable = _.some([...children], x => !!x?.options?.repeatable)

  const isParentsHasGrouping = _.some(
    [...parents],
    x => !!x?.options?.grouped_item_id
  )
  // const isChildrenHasGrouping = _.some(
  //   [...children],
  //   x => !!x?.options?.grouped_item_id
  // )

  // When there's any repeatable or custom grouped item in the branch, prevent nesting
  return {
    repeatable: isParentsHasGrouping,
    grouping: isChildrenHasRepeatable
  }
}
//******************  ******************//
export const delItem = (selected) => {
  const tempState = _.cloneDeep(store.getState().checklist.template.present)
  if (_.get(TemplateItems, `[${selected?.type}].type`) !== 'section') {
    const canContinue = CheckRelations({ items: [selected], action: { type: 'delete' } })
    if (!canContinue) {
      return false
    }
    tempState.items = tempState.items.filter(i => i?.id !== selected?.id)
  } else {
    const children = [selected, ..._getChildren(selected)]
    const canContinue = CheckRelations({ items: children, action: { type: 'delete' } })
    if (!canContinue) {
      return false
    }
    tempState.items = _deleteAllChild(selected?.id, tempState.items)
  }
  store.dispatch(
    _editTemplate(
      tempState,
      () => {
        store.dispatch(setSelectedItem({}))
      }
    )
  )
}
//******************  ******************//
export const deleteMultipleItemsFromMultiSelectMode = (deletedItems, continueAnyway = false) => {
  const tempState = _.cloneDeep(store.getState().checklist.template.present)
  const canContinue = CheckRelations({ items: deletedItems, action: { type: 'delete_multiple' } })
  if (!canContinue && !continueAnyway) {
    hideMultiSelect()
    return false
  }
  tempState.items = tempState.items.filter(item => !deletedItems.find(x => x.id === item.id))
  store.dispatch(
    _editTemplate(
      tempState,
      () => {
        store.dispatch(setSelectedItem({}))
      }
    )
  )
  return true
}
//******************  ******************//
export const openItemParents = (itemId, callback) => {
  const tempState = _.cloneDeep(store.getState().checklist.template.present)
  const parent_ids = []
  const item = _.find(tempState?.items, x => x.id === itemId)
  let current_parent = _.find(tempState?.items, x => x?.id === item?.parent_id)
  while (current_parent?.id !== null) {
    if (current_parent?.id && current_parent?.parent_id) {
      parent_ids.push(current_parent.id)
      current_parent = _.find(tempState?.items, x => x?.id === current_parent?.parent_id)
    } else {
      break
    }
  }
  tempState.items = tempState.items.map(x => {
    if (parent_ids.indexOf(x.id) > -1) {
      return {
        ...x,
        collapsed: false
      }
    } else {
      return x
    }
  })
  store.dispatch(
    _editTemplate(
      tempState,
      () => {
        // store.dispatch(_setSelectedItem({}))
        setTimeout(() => {
          callback()
        }, 600)
      },
      false
    )
  )
}